import * as React from "react";
import { connect } from "react-redux";
import AnnualWellnessVisitUpdateHistory from "./Screen1/AnnualWellnessVisitUpdateHistory";
import AnnualWellnessVisitNo from "./Screen3/AnnualWellnessVisitNo";


class AnnualWellnessVisitFlow extends React.Component {

    handleNextPage = () => {
        const { selectedCareGapOption } = this.props;
        if (selectedCareGapOption === 'Yes, I have had one') {
            return <AnnualWellnessVisitUpdateHistory />
        } else {
            return <AnnualWellnessVisitNo />

        }
    }

    render() {
        return (
            <>
                {this.handleNextPage()}
            </>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        selectedCareGapOption: state.careGap.selectedCareGapOption,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualWellnessVisitFlow);
